import { useNavigate } from "react-router-dom";
import NoticeBanner from "components/common/NoticeBanner";

export default ({ onDismiss }: { onDismiss: () => void }) => {
  const navigate = useNavigate();

  return (
    <NoticeBanner
      title="🤔 Not sure how to get started?"
      subtext="Browse our Inspiration page for ideas on how to get the most out of Faye."
      buttonText="Explore"
      dismissible={true}
      onDismiss={onDismiss}
      onClick={() => navigate("/inspiration")}
      noMarginBottom={true}
    />
  );
};
